import Decimal from "decimal.js";
import { useTranslation } from "react-i18next";
import type { useAutoBet } from "./useAutoBet.js";
import type { AutoSettings } from "./AutoBetSession.js";
import { moneyInput } from "./betSettings.js";

export function AutoBetAction({
  auto,
  settings,
  valid,
  disabled,
  amount,
  currency,
  decimals,
}: {
  auto: ReturnType<typeof useAutoBet>;
  settings: AutoSettings;
  valid: boolean;
  disabled: boolean;
  amount: string;
  currency: string;
  decimals: number;
}) {
  const { t } = useTranslation();
  const net = new Decimal(auto.net);
  return (
    <button
      type="button"
      className={`cx-bet-action ${auto.running ? "cx-bet-action--auto" : "cx-bet-action--bet"}`}
      aria-label={t(auto.running ? "auto.stop" : "auto.start")}
      disabled={!auto.running && (disabled || !valid)}
      onClick={() => (auto.running ? auto.stop() : auto.start(settings))}
    >
      <strong>{t(auto.running ? "auto.stop" : "auto.start")}</strong>
      <small role="status">
        {auto.running ? (
          <>
            <span>{t("auto.progress", { current: auto.currentRound, total: auto.total })} ·</span>
            <span className={net.gt(0) ? "cx-auto-net--positive" : undefined}>
              {t("auto.net", { amount: `${net.gt(0) ? "+" : ""}${net.toFixed(decimals)}` })}
            </span>
          </>
        ) : auto.reason ? (
          t(`auto.reasons.${auto.reason}`)
        ) : (
          t("auto.ready", {
            count: settings.rounds,
            amount: moneyInput(amount)?.toFixed(decimals) ?? amount,
            currency,
          })
        )}
      </small>
    </button>
  );
}
